import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface SegmentConflictDialogProps {
  open: boolean
  editorName: string | null
  /**
   * True when the competing write is attributed to the current user — in practice
   * the AI assistant writing on their behalf. The server attributes agent writes to
   * the invoking user, so without this the dialog names the reader in the third
   * person and invents a colleague who isn't there.
   */
  isSelf?: boolean
  onKeepMine: () => void
  onLoadTheirs: () => void
}

export function SegmentConflictDialog({ open, editorName, isSelf = false, onKeepMine, onLoadTheirs }: SegmentConflictDialogProps) {
  const isOtherPerson = !isSelf && editorName !== null
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md [&>button]:hidden">
        <DialogHeader>
          <DialogTitle>
            {isOtherPerson
              ? `${editorName} saved changes to this section while you were editing`
              : 'Your AI assistant updated this section while you were editing'}
          </DialogTitle>
          <DialogDescription>
            {isOtherPerson
              ? 'Choose which version to keep. Either way, the other version stays safe in version history — nothing is lost.'
              : 'The assistant\'s changes were saved while you kept typing. Choose which version to keep — either way, the other one stays safe in version history.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="ghost" onClick={onLoadTheirs}>
            {isOtherPerson ? `Load ${editorName}'s version` : 'Load the AI version'}
          </Button>
          <Button onClick={onKeepMine}>Keep my version</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
